
export default {
    SendTreasury: 1, // xuất khẩu gửi kbnn
    SendTaxAuthorities: 2 //  xuất khẩu gửi cơ quan thuế
};